import React from "react";

import ItemData from "./ItemData";
import { DetailGroupType } from "../../../../../models";
import styles from "./groupData.scss";
import { resolveLastLineItem } from "../../../../../services";

const resolveContentClassName = (type: any) => {
  switch (type) {
    case DetailGroupType.valueOnly:
      return `${styles.content} ${styles.valueOnly}`;

    case DetailGroupType.valueWithTitle:
      return `${styles.content} ${styles.valueWithTitle}`;

    case DetailGroupType.textArea:
      return `${styles.content} ${styles.textArea}`;

    default:
      throw new Error(`This DetailGroupType is not supported: ${type}`);
  }
};

const GroupData = ({ sectionName, data, type, category, adId, hrPageName }) => (
  <section className={styles.wrapper}>
    <h2 className={styles.sectionName}>{sectionName}</h2>
    <div className={resolveContentClassName(type)}>
      {/* eslint-disable-next-line react/no-array-index-key */}
      {data.map((itemData: any, index: any) => (
        <ItemData
          key={index}
          data={itemData}
          type={type}
          lastLineItem={resolveLastLineItem(data, index)}
          category={category}
          adId={adId}
          hrPageName={hrPageName}
        />
      ))}
    </div>
  </section>
);

GroupData.defaultProps = {
  type: ""
};

export default GroupData;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/DetailsSection/GroupData/index.tsx